<script setup>
  const client = useStrapiClient()
  const { user } = useUser()

  const hasUnreadEmails = ref(false)
  const checkInterval = ref(null)

  async function checkUnreadEmails() {
    if (!user.value?.employment?.outlook?.email) return
    try {
      const response = await client('outlook/unread-emails', {
        method: 'GET'
      })
      hasUnreadEmails.value = response.hasUnreadEmails
    } catch (error) {
      console.error('Failed to check for unread emails:', error)
    }
  }

  onMounted(() => {
    checkUnreadEmails()
    checkInterval.value = setInterval(() => {
      checkUnreadEmails()
    }, 120000)
  })

  onBeforeUnmount(() => {
    if (checkInterval.value) {
      clearInterval(checkInterval.value)
    }
  })
</script>

<template>
  <Tooltip content="Messagerie">
    <NuxtLink class="relative font-special outline-none duration-300 hover:text-viking-500 focus-visible:text-viking-500" to="/ats/messagerie">
      <Icon fixed-width name="envelope" size="lg" type="solid" />
      <div class="absolute -right-0.5 bottom-0 h-2 w-2 rounded-full bg-viking-400" v-if="hasUnreadEmails" />
    </NuxtLink>
  </Tooltip>
</template>
